import { render } from "./PayBtn.vue?vue&type=template&id=25701a99&scoped=true&ts=true"
import script from "./PayBtn.vue?vue&type=script&lang=ts"
export * from "./PayBtn.vue?vue&type=script&lang=ts"

import "./PayBtn.vue?vue&type=style&index=0&id=25701a99&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25701a99"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QIcon});
